export default __webpack_public_path__ + "static/media/background-03.118332fe.webp";